import Param from '../../param';
import effectManager from '../effect';
import Util from '../../util';


const param = new Param();
const effect = new effectManager();
const util = new Util();

export default class MainVisual{
    constructor(w,h,pixelRato){


        this.w = w;
        this.h = h;


        this.scene;
        this.camera;
        this.renderer;
        this.controls;

        this.loaded = false;

        this.cover = {
            geo : "",
            mat : "",
            mesh: "",
            uniforms:""
        }; /* メインビジュアルのテクスチャ */
        this.pixelRato = pixelRato;

        this.renderMode = "normal"; /* low || normal FPSが低下していたら切り替え */

        this.time = 0;

    }
    init(){


        // scene ステージ
        this.scene = new THREE.Scene();

        this.camera = new THREE.PerspectiveCamera(50, this.w / this.h, 1, 1000);
        this.camera.updateProjectionMatrix();
        this.camera.position.z = 1;
        var _focus = new THREE.Vector3();
        _focus.set( 0, 0, 0 );
        this.camera.lookAt( _focus );

        // this.controls = new THREE.OrbitControls(this.camera);
        // this.controls.autoRotate = true;

        this.renderer = new THREE.WebGLRenderer({
            alpha              : true,
            antialias          : true,
            // stencil            : false,
            // depth              : false,
        });
        this.renderer.setSize(this.w, this.h);
        this.renderer.setClearColor(0xffffff,0);
        this.renderer.setPixelRatio(this.pixelRato);
        // this.renderer.autoClear = false;
        document.getElementById('p-kv-cover').appendChild(this.renderer.domElement);


        let _this = this;
        // _this.bg.geo = new THREE.PlaneBufferGeometry(2,1.125);
        // _this.cover.geo = new THREE.PlaneBufferGeometry(1*2,900/1600*2);
        _this.cover.geo = new THREE.PlaneBufferGeometry(1*2,this.h/this.w*2);

        _this.cover.uniforms = {
            time:{type:"f",value:1.0},
            adjust:{type:"f",value:(window.devicePixelRatio!==1)?0.8:0},
            resolution:{type:"v2",value:new THREE.Vector2()},
            mouse:{type:"v2",value:new THREE.Vector2()},
        }

        _this.cover.uniforms.resolution.value.x = _this.w;
        _this.cover.uniforms.resolution.value.y = _this.h;

        _this.cover.mat = new THREE.ShaderMaterial({
            uniforms: _this.cover.uniforms,
            vertexShader: param.webgl.mainvisual.shader.vert,
            fragmentShader: param.webgl.mainvisual.shader.frag,
            transparent   :true,
        });

        _this.cover.mesh = new THREE.Mesh( _this.cover.geo, _this.cover.mat );

        _this.scene.add( _this.cover.mesh );




    }

    render(mouse,renderMode,current) {

        this.renderer.antialias=(renderMode==="normal")?true:false;

        this.cover.mat.uniforms.time.value += 1;
        if(renderMode==="normal"&&current===0){
            this.time += 1;
            if(this.time ==30){
                this.time = 0;
                this.cover.mat.uniforms.mouse.value.x = mouse.x*100;
                this.cover.mat.uniforms.mouse.value.y = 1;
            }else{
                this.cover.mat.uniforms.mouse.value.x = 1;
                this.cover.mat.uniforms.mouse.value.y = 1;
            }
        }else{
            this.cover.mat.uniforms.mouse.value.x = 1;
            this.cover.mat.uniforms.mouse.value.y = 1;
        }

        this.renderer.render(this.scene, this.camera);



    }
    resize(w,h){
        this.w = w;
        this.h = h;

        this.cover.mat.uniforms.resolution.value.x = w;
        this.cover.mat.uniforms.resolution.value.y = h;
        if(this.camera===undefined) return;
        this.camera.aspect = this.w / this.h;
        this.camera.updateProjectionMatrix();

        this.renderer.setSize(this.w, this.h);

    }


}